import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

const useStyles = makeStyles((theme: any) => ({
  backButton: { position: "absolute", left: 0 },
}));

export default function BackButton({ isFirstPage, goBack }) {
  const classes = useStyles();

  return (
    <IconButton
      color="primary"
      className={classes.backButton}
      onClick={goBack}
      disabled={isFirstPage}
    >
      <ArrowBackIosIcon />
    </IconButton>
  );
}
